module.exports = __webpack_public_path__ + "static/media/Sea Captain.cba488e8.jpg";